const STORAGE_KEY = 'spark_pending_script_toast';
const MAX_AGE_MS = 60000;

/**
 * Call before `window.location.assign` so the next page can show the same toast (full reload clears React state).
 */
export function stashPendingRedirectToast({ message, variant }) {
  if (typeof sessionStorage === 'undefined' || message == null || String(message).trim() === '') {
    return;
  }
  try {
    sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({
        message: String(message),
        variant: variant || 'success',
        ts: Date.now(),
      })
    );
  } catch {
    // ignore quota / private mode
  }
}

/**
 * Read and remove one stashed toast (e.g. on app mount after redirect).
 * @returns {{ message: string, variant: string } | null}
 */
export function consumePendingRedirectToast() {
  if (typeof sessionStorage === 'undefined') {
    return null;
  }
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return null;
    }
    sessionStorage.removeItem(STORAGE_KEY);
    const data = JSON.parse(raw);
    if (!data || typeof data.message !== 'string') {
      return null;
    }
    if (data.ts != null && Date.now() - Number(data.ts) > MAX_AGE_MS) {
      return null;
    }
    return { message: data.message, variant: data.variant || 'success' };
  } catch {
    return null;
  }
}
